import { Interaction } from '@quadminds/client-apis/agents';
import { CHAT_MODE } from '../enums/chatMode.enum';
import { chatModeType } from '../types/Chat/Chat.types';

export const isKnowledgeConversation = (interactions?: Interaction[] | null): boolean =>
    interactions?.some(
        (interaction) =>
            (interaction as Interaction & { type?: string }).type === 'rag' ||
            (interaction as Interaction & { metadata?: { type?: string } }).metadata?.type === 'rag',
    ) ?? false;

export const getConversationMode = (interactions?: Interaction[] | null): chatModeType =>
    isKnowledgeConversation(interactions) ? CHAT_MODE.knowledge : CHAT_MODE.logistics;

export const shouldShowAgentVersionMismatch = ({
    mode,
    conversationAgentVersion,
    currentAgentVersion,
    isKnowledge,
}: {
    mode: chatModeType;
    conversationAgentVersion: string;
    currentAgentVersion: string;
    isKnowledge: boolean;
}): boolean => mode === 'logistics' && !isKnowledge && conversationAgentVersion !== currentAgentVersion;
